import gql from 'graphql-tag';

export default gql`
  mutation($input: PantryUpdateInput!) {
    updatePantrySYH(input: $input) 
  }
`;
